import { ReactNode } from 'react';

import { Stack } from '@mui/material';

import { attendanceProgressbarClasses, Progressbar, Root } from './styles';

export interface AttendanceProgressbarProps {
  value: number;
  label: ReactNode;
  color?: 'primary' | 'success' | 'error' | 'warning';
}

const AttendanceProgressbar = ({ value, label, color }: AttendanceProgressbarProps) => {
  return (
    <Root>
      <Progressbar color={color} size={100} variant="determinate" shape="circular" value={value} />
      <Stack justifyContent="center" alignItems="center" className={attendanceProgressbarClasses.label}>
        {label}
      </Stack>
    </Root>
  );
};
export default AttendanceProgressbar;
